/**
 * The documents a league publishes to its players.
 *
 * ONLY FIXED DOCUMENTS BELONG HERE. A rules book is written once, argued over
 * by a committee and then settled; a file is the honest way to hold it, and a
 * player wants the same seven pages the captains were sent.
 *
 * A SQUAD LIST IS NOT ONE OF THOSE, and deliberately is not in this list. It is
 * generated from the season the app is running — see SquadListDoc — because
 * that is the whole reason it exists: the league circulated a hand-made squad
 * PDF, the database drifted from it, and four seeds and two squad places were
 * wrong before anybody noticed. Uploading a ratings PDF alongside the rules
 * would rebuild exactly that trap, with the added cruelty that it would look
 * official. The card offers the live one instead.
 *
 * PURE and data-only, so a league that has no documents is a league this
 * returns nothing for, rather than a special case at the call site.
 */

export interface LeagueDoc {
  /** What the link says. */
  title: string;
  /** One line under it — what it is, and what it is for. */
  description: string;
  /** Path under the site root. Served as a static file, not through the API. */
  href: string;
  /** The name the file takes when saved, rather than the one it is stored under. */
  filename: string;
}

/**
 * Which documents belong to this league and this season.
 *
 * SCOPED TO THE SCORING SYSTEM rather than to the league alone, and that is not
 * fussiness: Society's Season 1 is archived and was played under different
 * rules, so offering the Season 2 rule book on that season's table would be
 * handing a player the wrong rules for the results they are looking at. The
 * same test the squad cap uses, for the same reason.
 */
export function docsFor(
  leagueSlug: string | null | undefined,
  scoringSystem: string | null | undefined,
): LeagueDoc[] {
  if (leagueSlug === 'society-team-league' && scoringSystem === 'season2') {
    return [
      {
        title: 'League rules',
        description:
          'Squads, pairings, scoring, bonus points, forfeits and the code of conduct — the full Season 2 rule book.',
        href: '/docs/society-team-league-season-2-rules.pdf',
        filename: 'The Society Team League — Season 2 Rules.pdf',
      },
    ];
  }
  return [];
}
